import React, { FC } from "react"

import { px } from "@mantine/core"
import { IconTemperature } from "@tabler/icons-react"
import dayjs from "dayjs"

import ChartCard from "../../../analytics/components/chart-card/ChartCard"
import { useHealth } from "../../../../contexts/health-context"
import { useLanguage } from "../../../../contexts/language-context"

type DeviceTempChartProps = unknown

const DeviceTempChart: FC<DeviceTempChartProps> = () => {
    const { data } = useHealth()
    const { L } = useLanguage()

    return (
        <ChartCard
            label={L("Processor temperature")}
            option={{
                grid: { top: 0, right: 0, bottom: px("1.25rem"), left: 0 },
                xAxis: { type: "time" },
                yAxis: { type: "value", show: false, min: 20, max: 100 },
                dataset: {
                    dimensions: [
                        { name: "timestamp", displayName: "", type: "time" },
                        { name: "temp", displayName: L("Temperature"), type: "float" },
                    ],
                    source: data.map(health => ({ ...health, timestamp: health.timestamp.toDate() })),
                },
                series: [
                    {
                        type: "line",
                        smooth: true,
                        symbol: "none",
                    },
                ],
                tooltip: { trigger: "axis", valueFormatter: (value: number) => value.toFixed(1) + " °C" },
                dataZoom: [{ type: "inside", startValue: dayjs().hour(4).toDate(), endValue: dayjs().toDate() }],
                visualMap: [
                    {
                        show: false,
                        type: "continuous",
                        min: 20,
                        max: 100,
                    },
                ],
            }}
            icon={IconTemperature}
        />
    )
}

export default DeviceTempChart
